"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var text_field_component_1 = __importDefault(require("../inputs/text-field.component"));
var translations_context_1 = __importDefault(require("../../context/translations/translations.context"));
var dropdown_component_1 = require("./dropdown.component");
var styled_components_1 = __importDefault(require("styled-components"));
var Container = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
exports.SearchField = styled_components_1.default(text_field_component_1.default)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  top: ", ";\n  left: 0;\n  right: 0;\n"], ["\n  position: absolute;\n  top: ", ";\n  left: 0;\n  right: 0;\n"])), function (_a) {
    var hasTitle = _a.hasTitle;
    return (hasTitle ? '23px' : '0');
});
var DropdownWithSearch = function (props) {
    var options = props.options, title = props.title, onBlur = props.onBlur, id = props.id, defaultOption = props.defaultOption;
    var inputRef = react_1.useRef(null);
    var _a = react_1.useState(false), isOpen = _a[0], setIsOpen = _a[1];
    var _b = react_1.useState(''), searchTerm = _b[0], setSearchTerm = _b[1];
    var getTranslation = react_1.useContext(translations_context_1.default).getTranslation;
    react_1.useEffect(function () {
        var _a;
        if (isOpen) {
            (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
        else {
            setSearchTerm('');
        }
    }, [isOpen]);
    var filteredOptions = (searchTerm &&
        options.filter(function (_a) {
            var label = _a.label;
            return label.toLowerCase().startsWith(searchTerm.toLowerCase());
        })) ||
        options;
    return (react_1.default.createElement(Container, null,
        react_1.default.createElement(dropdown_component_1.InternalDropDown, __assign({}, props, { isOpen: isOpen, onToggle: setIsOpen, options: filteredOptions })),
        isOpen && (react_1.default.createElement(exports.SearchField, { ref: inputRef, hasTitle: Boolean(title), id: id !== null && id !== void 0 ? id : 'asset-search', value: searchTerm, onBlur: onBlur, onChange: function (searchTerm) { return setSearchTerm(searchTerm); }, placeholder: title || defaultOption ? '' : getTranslation('GLOBAL:SEARCH') }))));
};
DropdownWithSearch.displayName = 'DropdownWithSearch';
exports.default = DropdownWithSearch;
var templateObject_1, templateObject_2;
//# sourceMappingURL=dropdown-with-search.component.js.map